<generic-container textAlign="left" bold="last" titleKey="HOW_MUCH_YOU_PAY">
    <app-pos-product-table></app-pos-product-table>
</generic-container>